import React from "react";

const VacancyPageContext = React.createContext();

export { VacancyPageContext };
